module.exports = {
    ROLE_USER: "ROLE_USER",
    ROLE_CONTENT: "ROLE_CONTENT",
    ROLE_ADMIN: "ROLE_ADMIN",
    ROLE_CSKH: "ROLE_CSKH",
    ROLE_INVITE: "ROLE_INVITE"
};